import "./dashboardCharts.css"
import { useGetDashBoardDataQuery, useGetEPBReceivedTillDateMutation } from '../../../services/announceElection'
import { useEffect, useState } from 'react'
import moment from 'moment'
import InputField from "../../../library/components/InputField"
import { Validators } from "../../../library/utilities/Validator"
import { FILED_IS_REQUIRED } from "../../../constants/constants"
import CustomModal from "../../../library/components/Modal/modal"
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal"

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    epbPinGenerated: "-",
    totalNoSV: "",
    totalEpbDownload: "",
    totalEpbPending: "",
    totalEpbBooked: "",
    downloadPercentage: "",
    participationPercentage: "",
    epbPinGeneratedWidth: "",
    totalNoSVWidth: "",
    totalEpbDownloadWidth: "",
    totalEpbPendingWidth: "",
    totalEpbBookedWidth: "",
    downloadPercentageWidth: "",
    participationPercentageWidth: ""
  })
  const { data: getDashboardData } = useGetDashBoardDataQuery()
  // const [highlighted, setHighlighted] = useState(false);
 const [epbCount,datap]=useGetEPBReceivedTillDateMutation()
//  const [epbRes,setEpbres] = useState({})
 const [errorValue, setErrorValue] = useState({});
 const [state,setState] = useState()
//  const [showModal,setShowModal] = useState(false)
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setHighlighted(prevState => !prevState);
  //   }, 2000);
 
  //   return () => clearInterval(interval);
  // }, []);
 
  // useEffect(()=>{
  //   epbCount({
  //     requestType:"get"
  //   }).unwrap().then((res)=>{
  //   setEpbres(res?.payload)
  //   })
  // },[])

  useEffect(() => {
    if (getDashboardData?.payload) {
      let dashPayload = getDashboardData?.payload
      let epbPinGeneratedOn = dashPayload?.epbPinGenOn==null?"-":moment(new Date(dashPayload?.epbPinGenOn)).format("DD-MM-YYYY hh:mm A")
      let totalEpbDownloadWidthCal = (((dashPayload?.totalEpbCount / dashPayload?.serviceVoters) * 100) > 0 && ((dashPayload?.totalEpbCount / dashPayload?.serviceVoters) * 100) <= 1) ? "1" : ((dashPayload?.totalEpbCount / dashPayload?.serviceVoters) * 100)
      let totalEpbPendingCal = (((dashPayload?.pendingEpbCount / dashPayload?.serviceVoters) * 100) > 0 && ((dashPayload?.pendingEpbCount / dashPayload?.serviceVoters) * 100) <= 1) ? "1" : ((dashPayload?.pendingEpbCount / dashPayload?.serviceVoters) * 100)
      let totalEpbBookedCal = (((dashPayload?.epbBooked / dashPayload?.serviceVoters) * 100) > 0 && ((dashPayload?.epbBooked / dashPayload?.serviceVoters) * 100) < 1) ? "1" : ((dashPayload?.epbBooked / dashPayload?.serviceVoters) * 100)
      let downloadPercentageCal = parseFloat(((dashPayload?.totalEpbCount / dashPayload?.serviceVoters) * 100)).toFixed(2)
      let participationPercentageCal = parseFloat(((dashPayload?.epbBooked / dashPayload?.serviceVoters) * 100)).toFixed(2)
      let epbPinGeneratedCal = dashPayload?.epbPinGenOn != null ? "100%" : "0%"
      setDashboardData({
        epbPinGenerated: epbPinGeneratedOn,
        totalNoSV: dashPayload?.serviceVoters,
        totalEpbDownload: dashPayload?.totalEpbCount,
        totalEpbPending: dashPayload?.pendingEpbCount,
        totalEpbBooked: dashPayload?.epbBooked,
        downloadPercentage: downloadPercentageCal,
        participationPercentage: participationPercentageCal,
        epbPinGeneratedWidth: epbPinGeneratedCal,
        totalEpbDownloadWidth: totalEpbDownloadWidthCal,
        totalEpbPendingWidth: totalEpbPendingCal,
        totalEpbBookedWidth: totalEpbBookedCal,
        downloadPercentageWidth: downloadPercentageCal,
        participationPercentageWidth: participationPercentageCal
      })
    }
  }, [getDashboardData])


  const getErrorValue = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setErrorValue({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };
  const handleChange = (key, value, valueName) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

// const updateCount = () =>{
//   let error = {};
//   if (
//     (!state?.UpdateepbReceivedTillDate || state?.UpdateepbReceivedTillDate === "") 
//   ) {
//     error["UpdateepbReceivedTillDate"] = "This Field is required";
//   }

//   if (Object.keys(error).length) {
//     setErrorValue(error);
//     return;
//   }

//   if(epbRes?.epbReceivedTillDate > state?.UpdateepbReceivedTillDate){
//     setShowModal(true)
//     return
//   }

// epbCount({
//   requestType: "save",
//   epbReceivedTillDate: state?.UpdateepbReceivedTillDate
//     }).unwrap().then((res)=>{
//       setState({})
//     setEpbres(res?.payload)
//     })
// }

  return (
    <>

{/* <CustomModal
            className="confirmation_modal"
            show={showModal}
            onClose={() => {
              setShowModal(false);
            }}
            size="500px"
            closeIcon={false}
            modalTitle={"Are You Sure ?"}
            children={
              <div>
                <p
                  style={{ fontSize: '16px', fontWeight: 'bold', color: 'black' }}
                >Previously Entered e-PB Count was : {epbRes?.epbReceivedTillDate}</p>
                <p
                  style={{ fontSize: '15px', fontWeight: 'bold', color: 'red' }}
                >
                  <span
                    style={{
                      color: 'red',
                      fontSize: '15px',
                      fontWeight: 'bold'
                    }}
                  >
                    Note:{' '}
                  </span>
                  You have to enter cumulative count of e-PB Received till date. Therefore, ensure the count being entered is greater than last updated count. <span
                    style={{
                      color: 'black',
                      fontSize: '13px',
                    }}
                  >
                    (i.e - You have entered  <span  style={{
                      color: 'red',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}>{state?.UpdateepbReceivedTillDate}</span> which is lesser then your previous e-PB count. )
                  </span>
                </p>
                <ConfirmationModal
                // title="You want to delete this"
                noOption={() => {
                  setShowModal(false);
                }}
                yesOption={()=>{
                  epbCount({
                    requestType: "save",
                    epbReceivedTillDate: state?.UpdateepbReceivedTillDate
                      }).unwrap().then((res)=>{
                        setState({})
                      setEpbres(res?.payload)
                      setShowModal(false)
                      })
                }}
              />
              </div>
            }
          /> */}

      <div class="col-md-12 dashboardChart ">
        <div class="row ">
          <div class="col-md-4">
            <div class="card l-bg-cherry">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-key mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">e-PB and PIN Transmitted On</h5>
                </div>
                <div class="row">
                  <div class="col-12" style={{ marginTop: "39px" }}>
                    <h6 style={{ textAlign: "center" }}>
                      {dashboardData.epbPinGenerated}
                    </h6>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-cyan1" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: dashboardData.epbPinGeneratedWidth }}></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card l-bg-blue-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-users mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Total No Of Service Voter</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-4">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.totalNoSV}
                    </h2>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-green" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: `${dashboardData?.totalNoSV > 0 ? "100%" : "0%"}` }}></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card l-bg-green-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-download mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Total e-PB Downloaded</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-5">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.totalEpbDownload}
                    </h2>
                  </div>
                </div>

                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100%" style={{ width: `${dashboardData.totalEpbDownloadWidth}%` }}></div>
                </div>
              </div>
            </div>
          </div>
         {/* {(datap.isSuccess && epbRes?.transmissionFlag=="Y" ) &&  <div class="col-md-4">
            <div class="card " className={highlighted ? ' card l-bg-attention-dark' : 'card l-bg-attentionBlink-dark'}>
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class=" mr-3 mt-3"></i></div>
                <div class="mb-4">
                <h5 class="card-title mb-0 card-text-alignment-ro-dashboard" style={{color:"black",fontSize:"17px"}}>Last Updated e-PB count : {epbRes?.epbReceivedTillDate}</h5>
                </div>
                <div class="mb-2">
                  <h6 class="card-title mb-1 card-text-alignment-ro-dashboard">Total e-PB Received till date ( cumulative )</h6>
                </div>
                <div class="row align-items-center attentionInput d-flex">
                <InputField
                  label={""}
                  id="UpdateepbReceivedTillDate"
                  placeholder="Enter cumulative count till date"
                  name="UpdateepbReceivedTillDate"
                  required={true}
                  type="number"
                  inputClass="col-md-12"
                  labelClass="col-md-0"
                  value={state?.UpdateepbReceivedTillDate}
                  onChange={(val) => handleChange("UpdateepbReceivedTillDate", val)}
                  getError={(val) => getErrorValue("UpdateepbReceivedTillDate", val)}
                  Error={errorValue}
                  validators={[
                    {
                      check: Validators.required,
                      message: FILED_IS_REQUIRED,
                    }, 
                  ]}
                />
                </div>
                <div >
<button class="button-50" role="button" onClick={updateCount}>Update</button>

                  {/* <div class="progress-bar l-bg-orange1" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0%" aria-valuemax="100%" style={{ width: `${dashboardData.totalEpbPendingWidth}%` }}></div> */}
                {/* </div>
              </div>
            </div>
          </div>} */} 
          <div class="col-md-4">
            <div class="card l-bg-orange-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-spinner mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Total e-PB Pending</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-5">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.totalEpbPending}
                    </h2>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-orange1" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0%" aria-valuemax="100%" style={{ width: `${dashboardData.totalEpbPendingWidth}%` }}></div>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="col-md-4">
            <div class="card l-bg-grey-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-bookmark  mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Total e-PB Booked</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-5">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.totalEpbBooked}
                    </h2>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-cyan" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: `${dashboardData.totalEpbBookedWidth}%` }}></div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div class="col-md-4">
            <div class="card l-bg-yellow-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-download mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Download %</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-5">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.downloadPercentage==="NaN"?"0.00":dashboardData?.downloadPercentage}
                    </h2>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-green" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: `${dashboardData.downloadPercentageWidth}%` }}></div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div class="col-md-4">
            <div class="card l-bg-cyan-dark">
              <div class="card-statistic-3 p-4 card-height-ro-dashboard">
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-people-group mr-3 mt-3"></i></div>
                <div class="mb-4">
                  <h5 class="card-title mb-0 card-text-alignment-ro-dashboard">Participation %</h5>
                </div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-8 mt-5">
                    <h2 class="d-flex align-items-center mb-0">
                      {dashboardData?.participationPercentage==="NaN"?"0.00":dashboardData?.participationPercentage}
                    </h2>
                  </div>
                </div>
                <div class="progress mt-1 " data-height="8" style={{ height: "8px" }}>
                  <div class="progress-bar l-bg-orange" role="progressbar" data-width="25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style={{ width: `${dashboardData.participationPercentageWidth}%` }}></div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default Dashboard
